import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);
export function SevenScene() {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.seven-section',
            start: '-30% top',
            end: '0%',
            scrub: 1,
            delay: 3,
            invalidateOnRefresh: true
        }
    });

    tl.to('.seven-section__bg-box', 1, { opacity: 1 });
    tl.fromTo('.seven-section .rte > *', 2, {
        autoAlpha: 0,
        y: '+=5vh'
    }, {
        autoAlpha: 1,
        y: 0,
        stagger: {
            each: 0.5,
            ease: 'power1.out',
        }
    });
}